import commonConstant from '../../common/_commonConstant';

export const getVehicleLicensePlate = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_LICENSE_PLATE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_LICENSE_PLATE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const searchVehicleLicensePlate = (state, action) => {
  switch (action.type) {
    case commonConstant.SEARCH_CAR_PLATE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SEARCH_CAR_PLATE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
